import { render, staticRenderFns } from "./DataTableSelect.vue?vue&type=template&id=0b0f8396"
import script from "./DataTableSelect.vue?vue&type=script&lang=js"
export * from "./DataTableSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports